import Vue from 'vue';

export const MODAL_CLOSED = 'closed by either "Close" or clicking outside';
export const bus = new Vue();
